import { QR_STYLES } from "./variables";

const QR_CODE_KEY = "qr-code";
const DEFAULT_QR_SIZE = "300";

function mapQrStyleToDotsType(style) {
  if (!style) return "extra-rounded";
  const normalized = String(style).toLowerCase();
  if (QR_STYLES.includes(normalized)) return normalized;
  return "extra-rounded";
}

export function buildQrCodeOptions(variableConfig = {}) {
  const attrs = variableConfig[QR_CODE_KEY] || {};
  const dotStyle = mapQrStyleToDotsType(attrs["data-qr-style"]);
  const color1 = attrs["data-qr-color1"] || "#000000";
  const color2 = attrs["data-qr-color2"] || "#3538cd";
  const isGradient = (attrs["data-qr-type"] || "linear") === "gradient";

  const dotsOptions = isGradient
    ? {
        type: dotStyle,
        gradient: {
          colorStops: [{ color1 }, { color2 }],
        },
      }
    : {
        type: dotStyle,
        color1,
      };

  return {
    width: DEFAULT_QR_SIZE,
    height: DEFAULT_QR_SIZE,
    dotsOptions,
  };
}

export function mapApiQrOptionsToStyling(qrCodeOptions = {}) {
  const dots = qrCodeOptions.dotsOptions || {};
  const type = dots.type || "extra-rounded";

  if (dots.gradient?.colorStops) {
    const stops = dots.gradient.colorStops;
    const color1 = stops[0]?.color1 || stops[0]?.color || "#000000";
    const color2 =
      stops[1]?.color2 || stops[1]?.color || stops[1]?.color1 || "#3538cd";

    return {
      type,
      gradient: {
        type: "linear",
        rotation: 0,
        colorStops: [
          { offset: 0, color: color1 },
          { offset: 1, color: color2 },
        ],
      },
    };
  }

  const color = dots.color1 || dots.color || "#000000";
  return { type, color };
}

export function getQrPreviewSize(qrCodeOptions = {}) {
  const width = Number(qrCodeOptions.width) || 200;
  const height = Number(qrCodeOptions.height) || width;
  return { width, height };
}
